import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export const formatRelativeTime = (date: string | null | undefined): string => {
  if (!date) return "";
  
  const now = dayjs();
  const targetDate = dayjs(date);
  const diffMinutes = now.diff(targetDate, "minute");
  const diffHours = now.diff(targetDate, "hour");
  const diffDays = now.diff(targetDate, "day");
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = now.diff(targetDate, "month");
  const diffYears = now.diff(targetDate, "year");

  if (diffMinutes < 60) {
    return `${diffMinutes} minute${diffMinutes !== 1 ? 's' : ''} ago`;
  }
  
  if (diffHours < 24) {
    return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
  }
  
  if (diffDays < 7) {
    return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
  }

  if (diffWeeks < 4) {
    return `${diffWeeks} week${diffWeeks !== 1 ? 's' : ''} ago`;
  }
  
  if (diffMonths > 0 && diffMonths < 12) {
    return `${diffMonths} month${diffMonths !== 1 ? 's' : ''} ago`;
  }
  
  if (diffYears >= 1) {
    return `${diffYears} year${diffYears !== 1 ? 's' : ''} ago`;
  }
  
  // If more than 4 weeks but less than 1 month, show the date
  return targetDate.format("DD/MM/YYYY");
}; 